import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';

import EntryPoint from './EntryPoint';

ReactDOM.render(
  <EntryPoint />,
  document.getElementById('root')
);